export default __webpack_public_path__ + "static/media/remove.7a74b09a.svg";